import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

import moment from '@g4/moment-utc';
import Layout from '@g4/boneyard/lib/Layout';
import Text from '@g4/boneyard/lib/Text';
import VerticalSpacing from '@g4/boneyard/lib/VerticalSpacing';

import FooterMenu from './FooterMenu';
import Markdown from '../Markdown';
import footerQuery from './footerQuery';

import SSRAwareQuery from '../SSRAwareQuery';

const { Footer, Strip } = Layout;

const propTypes = {
  copyright: PropTypes.string,
  invertedTheme: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.object,
};

const defaultProps = {
  invertedTheme: false,
};

const StyledNav = styled.nav`
  width: 100%;
`;

const Copyright = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Montserrat, Arial, sans-serif;
  padding: 0.625rem;
  text-align: center;
  color: ${props => props.theme.colors.hob.appMenu.link};
`;

const StyledFooter = styled(Footer)`
  background-color: ${props =>
    props.invertedTheme
      ? props.theme.colors.common.light
      : props.theme.colors.hob.footer.bg};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const SiteFooter = ({ invertedTheme, className, theme }) => (
  <SSRAwareQuery query={footerQuery}>
    {({ loading, error, data }) => {
      if (loading) {
        return null;
      }

      if (error) {
        throw error;
      }

      const { bottomMenu, mediaMenu, translations } = data.application;

      return (
        <StyledFooter invertedTheme={invertedTheme}>
          <Strip>
            <StyledNav className={className}>
              <FooterMenu bottomMenu={bottomMenu} mediaMenu={mediaMenu} />
            </StyledNav>
          </Strip>
          <VerticalSpacing size={{ xs: 1, sm: 0, md: 5 }} />
          <Copyright imgAlt="no image">
            <Text size={14}>
              <Markdown
                source={translations.common.copyright}
                data={{ year: moment().format('YYYY') }}
              />
            </Text>
          </Copyright>
          <VerticalSpacing size={{ xs: 3, sm: 0, md: 8 }} />
        </StyledFooter>
      );
    }}
  </SSRAwareQuery>
);

SiteFooter.propTypes = propTypes;
SiteFooter.defaultProps = defaultProps;

export default withTheme(SiteFooter);
